import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters.");
    if (password !== confirm) return toast.error("Passwords don't match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. You can sign in now.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F1EE] px-6 py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="font-display text-xl text-[#1A362D]" data-testid="brand-link">← Trackr</Link>
        <h1 className="font-display text-4xl mt-8">Choose a new password</h1>
        <p className="text-[#5C6B64] mt-2">Pick something you'll remember.</p>

        {!token ? (
          <p className="mt-8 text-[#C65D47]" data-testid="reset-invalid">This reset link is missing a token. Request a new one.</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 mt-8">
            <div>
              <Label htmlFor="password">New password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
                className="h-12 mt-1.5 bg-white" data-testid="reset-password-input" />
            </div>
            <div>
              <Label htmlFor="confirm">Confirm password</Label>
              <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6}
                className="h-12 mt-1.5 bg-white" data-testid="reset-confirm-input" />
            </div>
            <Button
              type="submit" disabled={loading}
              className="w-full h-12 rounded-full bg-[#1A362D] hover:bg-[#2C4A40] text-white"
              data-testid="reset-submit-btn"
            >
              {loading ? "Saving…" : "Set new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
